<h2 mat-dialog-title>Goal Comments - {{ data.targetConditionName }}
  <div style="font-size:13px">
    Comments can be saved at any time for any goal regardless of roadmap status.
    <div style="font-size:12px">
      @if (!data.appUser?.isAdminUser || data.userIsApproverForRegion) {
        <div>(You are commenting as a Regional Approver.)</div>
      }
      @if (data.userIsApproverForProfitCenter) {
        <div>(You are commenting as a designated Profit Center Approver.)</div>
      }
      @if (!data.userIsApproverForRegion && !data.appUser?.isAdminUser && !data.userIsApproverForProfitCenter) {
        <div>(You are commenting as a Project Team Member.)</div>
      }
      @if (data.appUser?.isAdminUser) {
        <div>(You are commenting as an Admin.)</div>
      }
    </div>
  </div>
</h2>

<mat-dialog-content>
  <div class="comments-container">
    <!-- Loading indicator -->
    @if (isLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (comments().length > 0) {
      <div class="d-flex p-2 flex-column-reverse">
        @for (c of comments(); track c.id; let isEven = $even; let isLast = $last) {
          <div [ngClass]="{'comment-latest-oncomp' : isLast }">
            <div class="comment-header" matTooltip="{{c.createdBy}} ({{c.createdBy}})" matTooltipPosition="below" matTooltipShowDelay="200">
              {{ c.createdBy ? c.createdBy : c.createdBy }}
              {{c.type == 'admin' ? ' - Admin' : c.type == 'ra' ? ' - Regional Approver' : c.type == 'pca' ? ' - Profit Center Approver' : c.type == 'pt' ? ' - Project Team' : ''}}
            </div>
            <div class="comment-comment">
              {{ c.commentText }}
            </div>
            <div class="comment-footer d-flex">
              <div class="p-2 me-auto">
                Roadmap Version {{ c.roadmapVersion }}
              </div>
              <div class="p-2 ms-auto">
                {{ c.createdOn| date: "mediumDate" }}
              </div>
            </div>
            @if (data.appUser?.isAdminUser) {
              <fa-icon style="cursor: pointer; color: red" [icon]="faTrashAlt" matTooltip="Quick-Delete this comment. You will not be prompted for confirmation."
              matTooltipPosition="below" matTooltipShowDelay="200" (click)="deleteComment(c.id!)"></fa-icon>
            }
            <hr>
          </div>
        }
      </div>
    } @else {
      <div class="p-2">
        <div class="comment-latest-oncomp">
          There are currently no comments.
        </div>
      </div>
    }
  </div>

  <div class="d-flex align-items-end">
    <div class="comment-box me-auto" style="width:100%;margin-bottom:8px;">
      <input autocomplete="off" matInput placeholder="Enter comments here" [(ngModel)]="newCommentText" style="width: 100%;"/>
    </div>
    <div class="p-2 ms-auto" style="display:inline-flex">
      <button mat-button type="button" style="color: #f44336c7" class="icon-btn" (click)="close()"
        matTooltip="Close this window, do not save changes."  matTooltipPosition="right" matTooltipShowDelay="150">
        <fa-icon [icon]="faWindowClose"></fa-icon>
      </button>
      <button mat-button default style="color: #0071bbc2" class="icon-btn" (click)="save()"
        matTooltip="Save comment to goal, then close this window." matTooltipPosition="right" matTooltipShowDelay="150">
        <fa-icon [icon]="faReply"></fa-icon>
      </button>
    </div>
  </div>
</mat-dialog-content>
